export default __webpack_public_path__ + "static/media/moonbeam.aa1c3648.svg";